import React from "react";
import { Box, Typography } from "@mui/material";
import Play from "../components/common/GalleryComponent/Play";
import video from "../assets/images/video.png";
import inspection from "../assets/svgs/inspection.svg";
import pro from "../assets/svgs/Pro.svg";
import escrow from "../assets/svgs/escrow.svg";
import play from "../assets/svgs/play.svg";
import Button from "../components/common/Button/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AboutNav from "../components/nav/AboutNav";

function ProMachinery() {
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <>
      <AboutNav theme="dark" />
      <Box sx={{ backgroundColor: { xs: "#EBEBEB", sm: "white" } }}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: { xs: "auto", sm: "990px" },
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: { xs: "white", sm: "#283237" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: {
                xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
                sm: "none",
              },
              borderRadius: { xs: "0px 0px 8px 8px", sm: "0" },
              paddingBottom: { xs: "24px", sm: "0" },
              marginBottom: { xs: "16px", sm: "0" },
            }}
          >
            {mobMatch && (
              <ArrowBackIcon
                sx={{
                  color: "primary.main",
                  marginTop: "16px",
                  marginLeft: "24px",
                  alignSelf: "start",
                }}
              />
            )}
            <Typography
              variant={mobMatch ? "h3" : "h1"}
              fontWeight={mobMatch ? "600" : "700"}
              fontSize={mobMatch ? "22px" : "48px"}
              lineHeight={mobMatch ? "26px" : "52px"}
              color={mobMatch ? "text.primary" : "white"}
              sx={{
                textAlign: { xs: "left", sm: "center" },
                width: { xs: "343px", sm: "790px" },
                marginTop: { xs: "32px", sm: "72px" },
                marginBottom: { xs: "8px", sm: "24px" },
              }}
            >
              Buy heavy machinery online and complete your purchase from the
              comfort of your desk
            </Typography>
            <Typography
              variant={mobMatch ? "caption" : "body1"}
              fontWeight="400"
              fontSize={mobMatch ? "12px" : "16px"}
              lineHeight={mobMatch ? "16px" : "24px"}
              color={mobMatch ? "#616161" : "#D6D6D6"}
              sx={{
                width: { xs: "91.46%", sm: "71.43%" },
                textAlign: { xs: "left", sm: "center" },
              }}
            >
              With Machinery Planet PRO, you can buy heavy machinery online and
              complete your purchase from the comfort of your desk. Choose from
              a wide list of Inspected machines with a money-back guarantee if
              the machinery you receive is not as advertised. Pay for your
              machinery through a secure and trusted channel,escrow.com (World’s
              no.1 escrow service).
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: { xs: "#283237", sm: "transparent" },
              boxShadow: {
                xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
                sm: "none",
              },
              borderRadius: { xs: "8px", sm: "0" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginY: { xs: "18px", sm: "0" },
                marginTop: { xs: "18px", sm: "58px" },
                width: { xs: "343px", sm: "50.59%" },
                height: { xs: "192px", sm: "477.68px" },
                backgroundImage: `url(${video})`,
                backgroundSize: "cover",
                borderRadius: "16px",
                border: "1px solid #1F1F1F",
                filter:
                  "drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))",
              }}
            >
              <Box>
                <Play
                  sx={{
                    minWidth: "96px",
                    minHeight: "96px",
                    boxShadow:
                      "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
                  }}
                  icon={
                    <img
                      src={play}
                      width="34.29px"
                      height="44.57px"
                      style={{ objectFit: "cover" }}
                    />
                  }
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: { xs: "100%", sm: "53.57%" },
            marginY: { xs: "16px", sm: "72px" },
            marginX: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            boxShadow: {
              xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
              sm: "none",
            },
            borderRadius: { xs: "8px", sm: "0" },
          }}
        >
          <Typography
            variant={mobMatch ? "h3" : "h2"}
            fontWeight={mobMatch ? "600" : "700"}
            fontSize={mobMatch ? "22px" : "32px"}
            lineHeight={mobMatch ? "26px" : "36px"}
            color="text.primary"
            sx={{
              marginTop: { xs: "24px", sm: "0" },
              textAlign: "center",
              marginBottom: { xs: "32px", sm: "72px" },
            }}
          >
            Why Pro Machinery?
          </Typography>
          <Card
            head="1. Inspections"
            body="Every Machinery advertised on Machinery Planet PRO will have a Pre-Purchase Inspection conducted by an independent third-party provider at NO additional cost. Pre-Purchase Inspection provides you the transparency regarding the safety condition and reliability of the machinery. If any machinery does not pass the Inspection, we simply will not sell it."
            img={<img src={inspection} width="163.29px" height="152.27px" />}
          />
          <Box sx={{ height: { xs: "32px", sm: "56px" } }}></Box>
          <Card
            head="2. Secure payment"
            body="To ensure security of your payment, all payments made to Machinery Planet are managed through Escrow.com (Worlds #1 escrow services). You also receive live access to monitor the status of your funds on escrow.com."
            img={
              <img
                src={escrow}
                width={mobMatch ? "250px" : "326px"}
                height="63px"
              />
            }
            direction="row-reverse"
          />
          <Box sx={{ height: { xs: "32px", sm: "56px" } }}></Box>
          <Card
            head="3. Money-back Guarantee"
            body="We give you up to 7 business days from the arrival of the machinery at the port to inspect and make sure the machinery you received is as advertised. If you find out that the machinery is not as advertised, we will give you a full refund through Machinery Planet PROtect."
            img={
              <img
                src={pro}
                width="70.83px"
                height="80px"
                style={{ objectFit: "cover" }}
              />
            }
            tx="Money Back Guarantee"
          />
          {mobMatch && <Box sx={{ height: "24px" }}></Box>}
        </Box>
        <Box
          sx={{
            width: "100%",
            height: { xs: "276px", sm: "268px" },
            paddingY: { xs: "24px", sm: "72px" },
            display: "flex",
            marginBottom: "72px",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#283237",
            boxShadow: {
              xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
              sm: "none",
            },
            borderRadius: { xs: "8px", sm: "0" },
          }}
        >
          <Typography
            variant="h3"
            fontWeight="600"
            fontSize="22px"
            lineHeight="26px"
            color="#D6D6D6"
            sx={{
              textAlign: "center",
              marginBottom: "24px",
              width: { xs: "343px", sm: "71.43%" },
            }}
          >
            If you’re looking to buy heavy machinery online from the comfort of
            your desk, explore inspected machinery with Money-back Guarantee
            through Machinery Planet PROtect.
          </Typography>
          <Button
            variant="contained"
            bgColor="#F9D548"
            txColor="text.primary"
            size="lg"
            sx={{
              height: "48px !important",
              width: "207px",
              boxShadow: "none",
            }}
            hoverBg="#F3C04F"
          >
            Explore Pro Machinery
          </Button>
        </Box>
        {mobMatch && <Box sx={{ height: "16px" }}></Box>}
      </Box>
    </>
  );
}

function Card({ head, body, img, direction = "row", tx }) {
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: direction },
        columnGap: { xs: "0px", sm: "56px" },
        alignItems: "center",
        backgroundColor: "white",
      }}
    >
      <Box
        sx={{
          display: { xs: "flex", sm: "block", flexDirection: "column" },
          marginBottom: { xs: "32px", sm: "0" },
        }}
      >
        <Typography
          variant={mobMatch ? "subtitle1" : "h3"}
          fontWeight="600"
          fontSize={mobMatch ? "16px" : "22px"}
          lineHeight={mobMatch ? "24px" : "26px"}
          color="text.primary"
          sx={{ textAlign: { xs: "center", sm: "left" }, marginBottom: "8px" }}
        >
          {head}
        </Typography>
        <Typography
          variant={mobMatch ? "body2" : "body1"}
          fontWeight="400"
          fontSize={mobMatch ? "14px" : "16px"}
          lineHeight={mobMatch ? "20px" : "24px"}
          color="#616161"
          sx={{
            textAlign: { xs: "center", sm: "left" },
            width: { xs: "343px", sm: "422px" },
          }}
        >
          {body}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: { xs: "327px", sm: "422px" },
          height: { xs: "237px", sm: "300px" },
          backgroundColor: "#F5F5F5",
          boxShadow:
            "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2)",
          borderRadius: "16px",
        }}
      >
        {img}
        {tx && (
          <Typography
            variant="h3"
            fontWeight="600"
            fontSize="22px"
            lineHeight="26px"
            color="#000000"
            sx={{ textAlign: "center", width: "130px", marginTop: "8px" }}
          >
            {tx}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default ProMachinery;
